<template>
  <div class="scene-select-box" style="margin-bottom: 0;" v-if="isReady">
<!--    编辑器-->
    <div class="scene-select-box-main" v-if="!isShow" :style="'max-width: '+widthDiv+'px;'">
      <div class="scene-select-but" @click="toclick(-1)"><img src="/static/main/prev.png"></div>
      <div style="width: 100%;height: 110px;overflow-x: auto;" id="sceneSelectMain">
        <div id="sceneList" :style="'width:' + sceneList.length * 110 + 'px;background: #fff;'">
          <li v-for="scene in sceneListData" draggable="true" :key="scene.thumburl" :id="'scene' + scene.index"
            :class="currentSceneId == scene.index ? 'hotspot-detail-scene-selected' : ''"
            :style="'background: url(' + scene.thumburl + ') no-repeat;background-size: 100% 100%;display: flex;align-items: flex-end;'"
            @click.stop="clickToggleScene(scene)" @dragstart="dragstart" @dragend="dragend">
            <img src="/static/main/del.png" class="sceneDel" @click.stop="delScene(scene)">
            <p style="width: 100%;overflow: hidden;padding:4px 5px;background: #00000090;word-break:break-all; word-wrap:break-word;text-align: center; height: 20px;line-height: 20px; " v-if="scene.remark">{{ scene.remark }}</p>
            <div>
            </div>
          </li>
        </div>
      </div>
      <div class="scene-select-but" @click="toclick(1)"><img src="/static/main/next.png"></div>
    </div>
<!--    小程序-->
    <div class="scene-select-box-main1" v-if="isShow">
      <div class="scene-select-but" @click="toclick(-1)"><img src="/static/main/prev.png"></div>
      <div style="width: 100%;height: 110px;overflow-x: auto;" id="sceneSelectMain">
        <div id="sceneList" :style="'width:' + sceneList.length * 110 + 'px;background: #fff;'">
          <li v-for="scene in sceneListData" :key="scene.thumburl" :id="'scene' + scene.index"
            :class="currentSceneId == scene.index ? 'hotspot-detail-scene-selected' : ''" style="position: relative;">
            <img :src="scene.thumburl" @click="clickToggleScene(scene)" />
            <p style="width: 100%;overflow: hidden;padding:4px 5px;background: #00000090;word-break:break-all; word-wrap:break-word;text-align: center; height: 20px;line-height: 20px;position: absolute;bottom: 0; " v-if="scene.remark">{{ scene.remark }}</p>
            <div>
            </div>
          </li>
        </div>
      </div>
      <div class="scene-select-but" @click="toclick(1)"><img src="/static/main/next.png"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavList",
  props: {
    krpano: {
      require: true,
    },
    isShow: {
      require: true,
    },
    // 场景集合
    sceneList: {
      require: true,
    },
    sceneListNumData: {
      require: true,
    },

    // 当前场景的索引
    currentSceneId: {
      type: [Number, String],
      require: true,
    },
  },
  emits: [
    "goToScene", // 跳转视图
  ],
  data() {
    return {
      isUserView: false,
      sceneleft: 0,
      sceneclickn: 0,
      dragMoveStart: 0,
      dragMoveEnd: 0,
      sceneListData: [],
      isdrag: false,
      isSort: false,
      numData: [],
      isReady: false,
      widthDiv:0,
    };
  },
  watch: {
    currentSceneId: {
      handler(newVal) {
        if (newVal) {
          console.log("用户查看页面", newVal);
        }
      },

    },
    sceneListNumData: {
      handler(newVal) {
        console.log("场景排序", newVal);
        if (newVal) {
          if (newVal.length > 0) {
            this.numData = newVal
            this.changeSort()
          }
        }
      },
    },
    sceneList: {
      handler(newVal) {
        if (newVal) {
          let numData = []
          newVal.forEach((item, index) => {
            this.sceneListData.push(item)
            numData.push(item.index)
          })
          // console.log("场景排序", numData);
          // console.log("场景排序", this.numData.length );
          if (this.numData.length == 0) {//如果场景排序为空，则默认排序

            this.numData = numData
            this.isReady = true
            // this.sceneListNumData = numData
            // console.log("场景排序", this.numData);
          } else {
            // console.log("场景排序isSort", this.numData.length);
            this.isSort = true
          }
          //设置导航的宽度
          // console.log(window,'window.innerWidth')
          // console.log(window.clientWidth)
          this.widthDiv =window.innerWidth-250
          // console.log("widthDiv", this.widthDiv);
        }
      },
    },
  },
  mounted() {
    //   slider.addEventListener('mousemove', (e) => {
    // if (isDown) {
    //   slider.style.left = `${e.clientX - slider.offsetWidth / 2}px`; // 保持滑块在鼠标下方
    // }
    // });

  },
  methods: {
    //删除单个场景
    delScene(scene){
      // console.log(scene,'111111111')
      this.$emit('delScenceId',scene)

    },
    changeSort() {
      if (!this.isdrag) {//如果没有执行拖拽功能
        // console.log("如果没有执行拖拽功能", this.numData);
        // console.log("this.isSort", this.isSort);
        //如果已经排序过了，则直接使用排序后的数据,
        let times = setTimeout(() => {
          if (this.isSort) {
            this.sceneListData = []
            this.numData.forEach((item, index) => {
              this.sceneListData.push(this.sceneList[item])
            })
          }
          clearTimeout(times)
          this.isReady = true
        }, 200)
      } else {

        this.isReady = true
      }
    },
    dragstart(e) {
      // console.log(e)
      // console.log('dragstart')
      this.dragMoveStart = e.clientX
    },
    dragend(e) {
      // console.log(e)
      // console.log('dragend')
      this.dragMoveEnd = e.clientX
      this.dragChange()
    },
    dragChange() {
      // console.log(this.dragMoveStart, this.dragMoveEnd)
      if (this.dragMoveStart < this.dragMoveEnd) {//如果图片时向右移动
        this.dragMoveEnd - 110
      }
      let startI = Math.floor(this.dragMoveStart / 110)//计算开始移动前，鼠标点的是哪个图片
      let endI = Math.floor(this.dragMoveEnd / 110)//计算移动后，鼠标移动到哪张图片的位置、

      console.log(startI, endI)
      // console.log(this.sceneList)
      // let index = this.sceneList.findIndex((item,index) => index === startI);
      if (endI > this.sceneListData.length) {
        endI = this.sceneListData.length
      } else if (endI < 1) {
        endI = 1
      }
      console.log(startI, endI)
      console.log(startI - 1, endI - 1)
      this.sceneListData.splice(endI - 1, 0, this.sceneListData.splice(startI - 1, 1)[0]);//移动位置
      // console.log(this.sceneList)
      let sceneListNum = []
      this.sceneListData.forEach((item) => {
        sceneListNum.push(item.index)
      })
      this.isdrag = true
      console.log(sceneListNum)
      //数据返给父级页面
      this.$emit('changeScence', sceneListNum)
      console.log(this.sceneList)
    },
    mousedown(e) {
      let sceneList = document.getElementById("sceneList");
      sceneList.style.left = `${e.clientX - sceneList.offsetWidth / 2}px`; // 保持滑块在鼠标下方
    },
    /**
     * 点击切换场景
     */
    clickToggleScene(scene) {
      console.log(scene)
      // 点击的还是当前场景拦截
      if (this.currentSceneId === scene.index) return;
      this.$emit(
        "goToScene",
        {
          peak_to_scene: scene.name,
          peak_to_sceneId: scene.index,
        },
        1
      );
    },
    addPano() {
      this.$emit("addPano")
    },
    toclick(e) {
      let sceneSelectWidth = document.getElementById("sceneSelectMain").clientWidth;//获取显示区域的宽度
      let sceneListWidth = document.getElementById("sceneList").clientWidth;//获取总的宽度
      let sceneListView = document.getElementById("sceneList");
      if (this.sceneclickn + e < this.sceneListData.length && this.sceneclickn + e >= 0) {
        this.sceneclickn = this.sceneclickn + e;//计算向左向右点击次数
      } else {
        return false
      }
      //如果正常往后走
      if (sceneSelectWidth > this.sceneclickn * 110) {
        sceneListView.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
      } else if (sceneSelectWidth < this.sceneclickn * 110 && this.sceneclickn * 110 < sceneListWidth - sceneSelectWidth) {
        sceneListView.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
      } else if (this.sceneclickn * 110 > sceneListWidth - sceneSelectWidth) {
        sceneListView.scrollIntoView({ behavior: "smooth", block: "start", inline: "end" });
      } else {
      }
      //选中列表中的下一个场景

      // let indexi = this.currentSceneId + e
      // this.sceneListNumData[indexi]
      console.log(this.currentSceneId)
      console.log(this.numData)
      console.log('sceneclickn', this.sceneclickn)

      this.numData.forEach((item, index) => {
        console.log('item', item, 'index', index, 'this.currentSceneId', this.currentSceneId)
        if (item == this.currentSceneId) {
          let indexi = index + e
          let data = {
            index: this.sceneListData[indexi].index,
            name: this.sceneListData[indexi].name,
          }
          this.clickToggleScene(data)
        }
      })
      // let data = {
      //   index: this.sceneListData[indexi].index,
      //   name: this.sceneListData[indexi].name,
      // }
      // this.clickToggleScene(data)
    },
  },
};
</script>

<style lang="scss" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.scene-select-box {
  width: 100%;
  display: flex;

  .scene-select-box-main {
    background: #363636;
    margin: 10px 0;
    width: 100%;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 10px;

    .scene-select-but {
      width: 20px;
      height: 110px;
      display: flex;

      img {
        width: 20px;
        height: auto;
      }
    }

    .scene-select-main {
      display: flex;
      width: 98%;
      margin: 0 1%;
      // overflow: hidden;
      position: relative;
      height: 110px;

      ul {
        display: block;
        border-radius: 4px;
        box-sizing: border-box;
        width: 100%;
        height: 100px;
        overflow: auto;
        -ms-overflow-style: none;
        /* 隐藏滚动条 */
        scrollbar-width: none;
        /* 隐藏滚动条 */
        position: absolute;

        li {
          border-radius: 5px;
          box-sizing: border-box;
          margin: 0px 5px;
          width: 100px;
          height: 100px;
          overflow: hidden;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }

          div {
            text-align: center;
          }

          &.hotspot-detail-scene-selected {
            border: solid #409eff 2px;

          }
        }
      }

      //   ul::-webkit-scrollbar {
      // overflow: auto;
      // -ms-overflow-style: none;  /* 隐藏滚动条 */
      //   }
    }
  }
.sceneDel{width: 12px;height: 12px;position: absolute;top: 0; right: 0;z-index: 99999;background: #2E5CF6; padding: 6px;border-radius:0 0 0 5px;}
  .scene-select-box-main1 {
    background: #363636;
    margin: 10px 0;
    width: 90%;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 10px;
    position: fixed;
    bottom: 10px;
    left: 5%;
    z-index: 999;
    box-sizing: border-box;

    .scene-select-but {
      width: 20px;
      height: 100px;
      display: flex;

      img {
        width: 20px;
        height: auto;
      }
    }

    .scene-select-main {
      display: flex;
      width: 98%;
      margin: 0 1%;
      overflow: hidden;
      position: relative;
      height: 100px;

      ul {
        display: block;
        border-radius: 4px;
        box-sizing: border-box;
        width: 100%;
        height: 100px;
        overflow: auto;
        -ms-overflow-style: none;
        /* 隐藏滚动条 */
        scrollbar-width: none;
        /* 隐藏滚动条 */
        position: absolute;

      }

      //   ul::-webkit-scrollbar {
      // overflow: auto;
      // -ms-overflow-style: none;  /* 隐藏滚动条 */
      //   }
    }
  }
}

li {
  border-radius: 5px;
  box-sizing: border-box;
  margin: 0px 5px;
  width: 100px;
  height: 100px;
  overflow: hidden;
  float: left;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  div {
    text-align: center;
  }

  &.hotspot-detail-scene-selected {
    border: solid #409eff 2px;

  }
}

.scene-select-box-add {
  width: 80px;
  background: #363636;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 8px;
  padding: 5px;

  img {
    width: 20px;
    height: auto;
  }
}

/* 修改滚动条的宽度 */
::-webkit-scrollbar {
  width: 8px;
  /* 纵向滚动条的宽度 */
  height: 8px;
  /* 横向滚动条的高度 */
  background: #363636;
}

/* 滚动条轨道部分 */
::-webkit-scrollbar-track {
  background-color: #4D4D4D;
  border-radius: 10px;
}

/* 滚动条滑块部分 */
::-webkit-scrollbar-thumb {
  background-color: #666;
  border-radius: 10px;
}

/* 鼠标悬停在滑块上时 */
::-webkit-scrollbar-thumb:hover {
  background-color: #888888;
}

::-webkit-scrollbar-corner {

  background: #363636;
}
</style>
